<template>
  <div class="repayment-skeleton-container">
    <div class="skeleton-title" style="width: 120px;"></div>

    <div class="skeleton-box rental-info-box">
      <div class="skeleton-row">
        <div class="skeleton-text short"></div>
        <div class="skeleton-text medium"></div>
      </div>
      <div class="skeleton-row">
        <div class="skeleton-text short"></div>
        <div class="skeleton-text medium"></div>
      </div>
      <div class="skeleton-row">
        <div class="skeleton-text short"></div>
        <div class="skeleton-text medium"></div>
      </div>
      <div class="skeleton-row">
        <div class="skeleton-text short"></div>
        <div class="skeleton-text medium"></div>
      </div>
      <div class="skeleton-row">
        <div class="skeleton-text short"></div>
        <div class="skeleton-text medium"></div>
      </div>
      <div class="skeleton-row">
        <div class="skeleton-text short"></div>
        <div class="skeleton-text medium"></div>
      </div>
      <div class="skeleton-row">
        <div class="skeleton-text short"></div>
        <div class="skeleton-text medium"></div>
      </div>
      <div class="skeleton-row">
        <div class="skeleton-text short"></div>
        <div class="skeleton-text medium"></div>
      </div>
      <div class="skeleton-row">
        <div class="skeleton-text short"></div>
        <div class="skeleton-text medium"></div>
      </div>
    </div>

    <div class="skeleton-title" style="width: 190px; margin-top: 11px;"></div>

    <div class="skeleton-box payment-method-box">
      <div class="skeleton-icon"></div>
      <div class="skeleton-text medium" style="margin-left: 12px;"></div>
      <div
        class="skeleton-icon"
        style="margin-left: auto; border-radius: 50%; width: 18px; height: 18px;"
      ></div>
    </div>

    <div class="skeleton-box payment-method-box">
      <div class="skeleton-icon"></div>
      <div class="skeleton-text medium" style="margin-left: 12px;"></div>
      <div
        class="skeleton-icon"
        style="margin-left: auto; border-radius: 50%; width: 18px; height: 18px;"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RepaymentSelectSkeleton",
};
</script>

<style scoped>
.repayment-skeleton-container {
  width: 343px;
  margin: 0 auto;
  z-index: 999;
  pointer-events: none;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.skeleton-title {
  height: 19.09px;
  background-color: #e0e0e0;
  border-radius: 4px;
}

.skeleton-box {
  border-radius: 5px;
  box-shadow: 0px 1px 21.3px 0px rgba(0, 0, 0, 0.04);
}

.rental-info-box {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.skeleton-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.payment-method-box {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.skeleton-icon {
  width: 28px;
  height: 28px;
  background-color: #e0e0e0;
  border-radius: 4px;
}

.skeleton-text {
  height: 18px;
  background-color: #e0e0e0;
  border-radius: 4px;
}

.short {
  width: 40%;
}

.medium {
  width: 60%;
}

.long {
  width: 100%;
}

.repayment-skeleton-container > div {
  animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}
</style>

